@if (isVisible) {
    <div class="lv-user-widget">
        <button
            id="lv-user-widget-btn"
            class="lv-user-widget__button"
            type="button"
            aria-haspopup="true"
            [attr.aria-expanded]="state.showDialog().user"
            (click)="state.toggleDialog('user')"
        >
            <span>{{ abbreviatedName }}</span>
        </button>

        <div
            baasClickOutside
            class="lv-header-widget__dialog"
            [class.lv-header-widget__dialog--open]="state.showDialog().user"
            (clickOutside)="state.toggleDialog('user')"
            [clickOutsideEnabled]="state.showDialog().user"
            exclude="#lv-user-widget-btn"
            aria-labelledby="lv-user-widget-btn"
        >
            <div class="lv-header-widget__header">
                <div class="lv-header-widget__title">{{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.USER.TITLE' | i18n }}</div>
                <button matIconButton class="lv-header-widget__close" style="margin: 0.5rem" aria-label="Sluiten" (click)="state.toggleDialog('user')">
                    <mat-icon class="fa fa-times"></mat-icon>
                </button>
            </div>
            <div class="lv-header-widget__content">
                <ul class="lv-header-widget__list">
                    <li>
                        <span class="lv-header-widget__list-item">
                            <span class="lv-header-widget__icon far fa-user" aria-describedby="lv-widget-user"></span>
                            <span class="lv-header-widget__description" id="lv-widget-user">
                                <span>{{ name }}</span>
                                @if (clientNumber) {
                                    <span class="d-flex align-items-center">
                                        <span> {{ parsedClientNumber }} </span>
                                        <a
                                            mat-icon-button
                                            class="border-0"
                                            style="font-size: medium"
                                            [matTooltip]="'DOMAIN_STARTSCHERM.HEADER_WIDGET.USER.CLIENT_NUMBER_TOOLTIP' | i18n"
                                            (click)="copyClientNumber()"
                                            (keydown.enter)="copyClientNumber()"
                                            (keydown.space)="copyClientNumber()"
                                            tabindex="0"
                                        >
                                            <span class="far fa-copy"></span>
                                        </a>
                                    </span>
                                }
                            </span>
                        </span>
                    </li>
                    @if (state.isIntern) {
                        <li>
                            <a
                                (click)="toggleCompact($event)"
                                (keydown.enter)="toggleCompact($event)"
                                (keydown.space)="toggleCompact($event)"
                                class="lv-header-widget__list-item"
                                tabindex="0"
                            >
                                <span
                                    class="lv-header-widget__icon far"
                                    [class]="{ 'fa-check-square': compact(), 'fa-square': !compact() }"
                                    aria-describedby="lv-widget-compact"
                                ></span>
                                <span class="lv-header-widget__description" id="lv-widget-compact">
                                    <span> {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.USER.COMPACT' | i18n }} </span>
                                </span>
                            </a>
                        </li>
                        <li>
                            <div class="lv-header-widget__list-item">
                                <span class="lv-header-widget__icon fas fa-server" aria-describedby="lv-widget-omgeving"></span>
                                <span class="lv-header-widget__description" id="lv-widget-omgeving">
                                    <startscherm-omgevingen></startscherm-omgevingen>
                                </span>
                            </div>
                        </li>
                    } @else if (state.isExtern) {
                        <li>
                            <a (click)="logout()" (keydown.enter)="logout()" (keydown.space)="logout()" class="lv-header-widget__list-item" tabindex="0">
                                <span class="lv-header-widget__icon fa fa-sign-out-alt" aria-describedby="lv-widget-sign-out"></span>
                                <span class="lv-header-widget__description" id="lv-widget-sign-out">
                                    <span> {{ 'DOMAIN_STARTSCHERM.HEADER_WIDGET.USER.LOG_OUT' | i18n }} </span>
                                </span>
                            </a>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
}
